"use strict";

require("./import-log.factory.js");

angular.module("vendor")
.controller("SectionImportLogList", function($scope, $rootScope, $stateParams, ImportDocument, ImportLog) {
    var _this = this;

    $scope.filters = {
        "import_file_id": $stateParams.document
    }
    $scope.pagination = {};
    $scope.documentTypeLocalized = ImportDocument.getDocumentTypeLocalized();
    $scope.statusLocalized = ImportLog.getStatusLocalized();
    $scope.importLogService = ImportLog;
    $scope.currentFilter = "";

    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        $scope.documentTypeLocalized = ImportDocument.getDocumentTypeLocalized();
        $scope.statusLocalized = ImportLog.getStatusLocalized();
        _this.search();
    });

    $scope.$on("$destroy", function() {
        unregisterLanguageChanged();
    });

    this.fetchStatusWithFilter = function(status) {
        $scope.filters["type"] = status;
        _this.search();
    };

    this.search = function() {
        var page = $scope.pagination.current_page;
        var search = $stateParams.search;
        ImportLog.query(search, page, $scope.filters).$promise.then(function(data) {
            $scope.pagination = data.pagination;
            $scope.Logs = data.results;
        });
    };

    this.search();

});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/import/import-log-list.controller.js
// module id = 1012
// module chunks = 0